export default "<button [@testTrigger]='state' class='say-button say-button--primary' type='button'>\r\n    <ng-content></ng-content>\r\n</button>"